export const ERROR = {
  SYSTEM_ERROR: 'System Error. Please email us.',
  INVALID_PHONE_NUMBER: 'Please, enter a valid phone number. EX. +1 (234) 444-4444',
  ZIP_CODE_ERROR: 'Enter valid zip code.',
  INACCESSABLE: 'You don`t have access to this page!',
  INACTIVE_AGENCY_SUBSCRIPTION: 'In order to add a new user, you need to activate the subscription',
  SEATS_ERROR: 'Please purchase more seats to invite more members',
  USER_EXIST: 'User is already exist',
};
